import { Card, Button } from "antd";
import posifloraLogo from "src/assets/posiflora.png";

const { Meta } = Card;

export default function IntegrationPosiflora({ query }) {
  const handleClick = () => {
    const token = query?.token;
    if (token) {
      window.open(`https://t.me/posifloratablebot?start=${token}`, "_blank");
    }
  };

  return (
    <Card
      style={{ width: 250 }}
      cover={<img alt="posiflora" src={posifloraLogo} />}
      actions={[
        <Button key="setup" onClick={handleClick}>
          Установить виджет
        </Button>,
      ]}
    >
      <Meta title="Posiflora" />
    </Card>
  );
}
